export default [
  {
    path: '/monrec/bill',
    name: 'MonrecBill',
    component: () =>
      import(
        /* webpackChunkName: "land" */ '@/projects/operation/views/Billing/Land/MonrecBillManage.vue'
      )
  }
]
